import { parseFen2Yuan, parseYuan2Fen, Calculator } from '@/utils/number';
import getRandomId from '@/utils/uuid';

import { MainState, ReducerState } from '@/redux/reducers/reversal/goods';
import { getGoodsBillDetail } from '@/api/goodsReversal';

// 获取商品列表
export const getStateFromOrder: (billNo: string) => Promise<MainState> = async (billNo) => {
  const res = await getGoodsBillDetail(billNo);
  const billDetail = res.data || {};
  const goodsList = billDetail.productDetails || [];
  return {
    goodsList: goodsList.map((item) => {
      const { quantity, price, subtotal, standardPrice } = item;
      const totalCount = `${quantity}`;
      const totalValue = parseFen2Yuan(subtotal);
      return {
        ...item,
        indexId: getRandomId(),
        price: parseFen2Yuan(price),
        standardPrice: parseFen2Yuan(standardPrice),
        initCount: totalCount,
        initTotalValue: totalValue,
        currentCount: totalCount,
        currentTotalValue: totalValue,
      };
    }),
  };
};

// 提交数据
export const formatToSubmitData: (data: ReducerState) => { [key: string]: unknown } = (data) => {
  const { goodsList } = data;
  return {
    detail: goodsList.map((item) => {
      const {
        code,
        name,
        price,
        subject,
        initCount,
        currentCount,
        initTotalValue,
        currentTotalValue,
      } = item;
      return {
        code,
        name,
        subject,
        price: parseYuan2Fen(price),
        reconciledAmount: parseYuan2Fen(
          new Calculator(initTotalValue).minus(currentTotalValue).getValue(),
        ), // 冲调金额
        returnsNumber: new Calculator(initCount).minus(currentCount).getValue(), //	退货数量
      };
    }),
  };
};
